module.exports = __webpack_public_path__ + "static/img/token_img.dab65645.png";